import { render, staticRenderFns } from "./UserRecharge.vue?vue&type=template&id=2ae33b41&scoped=true&"
import script from "./UserRecharge.vue?vue&type=script&lang=js&"
export * from "./UserRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae33b41",
  null
  
)

component.options.__file = "UserRecharge.vue"
export default component.exports